<!-- 功德榜 -->
<template>
    <div class="religion-index-content">
        <!-- 公告栏：时间、通知 -->
        <div class="notice">{{new Date()}}</div>
        <!-- banner -->
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item>
                <img src="@assets/images/religion/b1.jpeg">
            </van-swipe-item>
            <van-swipe-item>
                <img src="@assets/images/religion/b2.jpeg">
            </van-swipe-item>
            <van-swipe-item>
                <img src="@assets/images/religion/b3.jpeg">
            </van-swipe-item>
            <van-swipe-item>
                <img src="@assets/images/religion/b4.jpeg">
            </van-swipe-item>
            <van-swipe-item>
                <img src="@assets/images/religion/b5.jpeg">
            </van-swipe-item>
            <van-swipe-item>
                <img src="@assets/images/religion/b6.jpeg">
            </van-swipe-item>
        </van-swipe>
        <!-- 寺庙简介 -->
        <div class="introduce">
            <div class="text">
                <p class="text-title">{{info.name}}</p>
                <p class="text-p">{{info.des}}</p>
            </div>
            <div class="ewm">
                <img class="ewm-img" src="@assets/images/religion/ewm.png">
                <p class="ewm-p">扫一扫，捐功德</p>
            </div>
        </div>
        <!-- 功德榜 -->
        <div class="table">
            <img class="wan wan-1" src="@assets/images/religion/wan.png">
            <img class="wan wan-2" src="@assets/images/religion/wan.png">
            <!-- <img class="wan wan-3" src="@assets/images/religion/wan.png"> -->
            <!-- <img class="wan wan-4" src="@assets/images/religion/wan.png"> -->
            <!-- 表头 -->
            <ul class="head">
                <li class="li-title">
                    <span class="head-img"></span>
                    <span class="name">姓名</span>
                    <span class="money">功德</span>
                    <span class="word">祈福语</span>
                </li>
            </ul>
           <!-- 滚动部分 -->
            <vueSeamless
              :data="tableData"
              class="seamless-warp"
              :class-option="optionSetting"
            >
              <li
                class="li-item"
                v-for="(item, i) in tableData"
                :key="i"
                :class="{on:(i+1)%2==0,off:(i+1)%2!=0}"
              >
                <span class="head-img">
                    <img class="user-img" src="@assets/images/religion/head.png"></img>
                </span>
                <span class="name" v-text="item.name"></span>
                <span class="money" v-text="'¥' + item.money"></span>
                <span class="word" v-text="item.word"></span>
              </li>
 			</vueSeamless>
        </div>
    </div>
</template>


<script >
import vueSeamless from 'vue-seamless-scroll'
export default {
    components: { vueSeamless },
    data() {
        return {
            info: {
                name: '开元寺',
                des: '开元寺位于福建省泉州市鲤城区西街，是中国东南沿海重要的文物古迹，也是福建省内规模最大的佛教寺院。该寺始创于唐初垂拱二年（686年），初名莲花道场，开元二十六年（738年）更名开元寺。现存主要庙宇系明、清两代修建，南北长260米，东西宽300米，占地面积78000平方米。'
            },
            tableData: [
                {
                    name: '金梦菲',
                    money: 200,
                    word: '全家平安，健健康康'
                },
                {
                    name: '尤金宝',
                    money: 200,
                    word: '全家平安，健健康康'
                },
                {
                    name: '西瓜瓜',
                    money: 200,
                    word: '祝愿全家平安，健健康康,心想事成，万事如意，阖家欢乐，开开心心，快快乐乐，永远开心，喜气洋洋'
                },
                {
                    name: '李永利',
                    money: 200,
                    word: '全家平安，健健康康'
                },
                {
                    name: '吴开心',
                    money: 200,
                    word: '祝愿全家平安，健健康康,心想事成，万事如意，阖家欢乐，开开心心，快快乐乐，永远开心，喜气洋洋'
                },
                {
                    name: '钱深深',
                    money: 200,
                    word: '祝愿全家平安，健健康康,心想事成，万事如意，阖家欢乐，开开心心，快快乐乐，永远开心，喜气洋洋'
                },
                {
                    name: '李子平',
                    money: 200,
                    word: '祝愿全家平安，健健康康,心想事成，万事如意，阖家欢乐，开开心心，快快乐乐，永远开心，喜气洋洋'
                },
            ]
        }
    },
    computed: {
        optionSetting() {
            return {
                step: 1, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            }
        }
    }
}
</script>

<style scoped>
.religion-index-content {
    background: #b37536;
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.religion-index-content .notice {    
    height: 0.5rem;
    /* flex-shrink:0 */
}  
.religion-index-content .my-swipe {
    /* flex-shrink:0 */
}
.religion-index-content .my-swipe .van-swipe-item {
    height: 4rem;
    
}
.religion-index-content .my-swipe img {
    height: 100%;
    width: 100%;
    
}
.religion-index-content .introduce {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 0.1rem 0.2rem;
    /* height: 4rem; */
}
.religion-index-content .introduce .text {
    width: 75%;
}
.religion-index-content .introduce .text-title {
    color: #000;
    font-size: 0.35rem;
    font-weight: bold;
    text-align: center;
}
.religion-index-content .introduce .text-p {
    overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      word-break: break-all;
}
.religion-index-content .introduce .ewm {
    width: 2rem;
}
.religion-index-content .introduce .ewm-img {
    width: 100%;
    height: 100%；
}
.religion-index-content .introduce .ewm-p {
    color: #dc0202;
    font-size: 0.2rem;
    font-weight: bold;
    text-align: center;
    width: 100%;
}
/* 功德榜 */
.religion-index-content .table {
    padding: 0rem 0.08rem 0.05rem;
    font-size: 0.12rem;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    /* flex: 1; */
    position: relative;
    color: #f9f9f9;
}
.religion-index-content .table .wan {
    width: 0.5rem;
    position: absolute;
}
.religion-index-content .table .wan-1 {
    left: 0;
}
.religion-index-content .table .wan-2 {
    right: 0;
}
.religion-index-content .table .wan-3 {
    left: 0;
    bottom: 0;
}
.religion-index-content .table .wan-4 {
    right: 0;
    bottom: 0;
}
.religion-index-content .table .head {
    display: flex;
    height: 0.7rem;
}
.religion-index-content .table li {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.religion-index-content .table .li-title {
    width: 100%;
    font-size: 0.25rem;
    font-weight: bold;
}
.religion-index-content .table .head-img {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.religion-index-content .table .user-img {
    width: 60%;
}
.religion-index-content .table .name {
    width: 15%;
    text-align: center;
}
.religion-index-content .table .money {
    width: 15%;
    text-align: center;
}
.religion-index-content .table .word{
    width: 55%;
    /* text-align: center; */
}
.religion-index-content .table .seamless-warp {
    overflow: hidden;
    /* flex: 1; */
    color: #f0f0f0;
    height: 5rem;
}
.religion-index-content .table .li-item {
    list-style: none;
    margin-bottom: 0.1rem;
    font-size: 0.25rem;
}
</style>
  